import { atom, selectorFamily } from 'recoil';
import { NotificationType } from '../types/notifications';

export const notificationTypesState = atom<NotificationType[]>({
  key: 'app.reports.notificationTypes',
  default: [],
});

export const notificationTypeState = selectorFamily<NotificationType | undefined, number>({
  key: 'app.reports.notificationType',
  get:
    (id) =>
    ({ get }) => {
      const notificationTypes = get(notificationTypesState);

      return notificationTypes.find((notificationType) => notificationType.notificationId === id);
    },
});
